import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useUnauthorizedResponse } from '@gov-nx/api/errors/utils';
import { useAppContext } from '@gov-nx/core/app/context/AppContext';
import { usePersonStore } from '@gov-nx/store/person/store';
import {
	robCommunicationQueryKey,
	useRobCommunicationQuery,
} from '../Contacts/query/useRobCommunicationQuery';

export const usePersonCommunicationLoader = () => {
	const { setAppError } = useAppContext();
	const setPersonCommunicationData = usePersonStore(
		'setPersonCommunicationData'
	);
	const { isUnauthorizedResponse } = useUnauthorizedResponse();

	const queryClient = useQueryClient();
	const initQuery = useRobCommunicationQuery({
		onSuccess: (data) => {
			setPersonCommunicationData(data);
		},
		onError: (e) => {
			if (isUnauthorizedResponse(e) === false) {
				setAppError(e as Error);
			}
		},
		cacheTime: 0,
		enabled: false,
		retry: 1,
	});

	const initPersonCommunication = useCallback(async (): Promise<void> => {
		await initQuery.refetch();
	}, [initQuery]);

	const refetchPersonCommunication = useCallback(async (): Promise<void> => {
		await queryClient.invalidateQueries({
			queryKey: robCommunicationQueryKey,
		});

		await initQuery.refetch();
	}, [initQuery, queryClient]);

	return {
		initPersonCommunication,
		refetchPersonCommunication,
		isReloading: initQuery.isFetching,
	};
};
